<template>
	<div class="speaker-wrapper">
		<Avatar class="mr-3 post-preview-card__avatar" :size="50" :avatar="speaker.speaker_logo" />
		<div class="speaker-wrapper__info">
			<div v-if="speaker.speaker_name" class="speaker-wrapper__info__name mb-1">
				{{ speaker.speaker_name }}
			</div>
			<div v-if="speaker.speaker_title" class="speaker-wrapper__info__company">
				{{ speaker.speaker_title }}
			</div>
			<div v-if="speaker.speaker_company" class="speaker-wrapper__info__company">
				{{ speaker.speaker_company }}
			</div>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'
import Avatar from '@/components/Avatar.vue'

Vue.use(VueScrollTo)

export default {
	name: 'SpeakerCard',
	components: {
		Avatar,
	},
	props: {
		speaker: {
			type: Object,
			default: () => ({}),
		},
	},
}
</script>

<style lang="scss">
.speaker-wrapper {
	display: flex;
	align-items: center;
	background-color: #ffffff;
	margin-bottom: 8px;
	border-radius: 8px;
	padding: 12px;
	border: 1px solid #e2e2e2;
	font-family: 'Inter', sans-serif;
	&__info {
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		height: 55px;
		&__name {
			color: var(--username-category-title);
			margin-bottom: 4px !important;
			font-weight: 700;
			font-size: 16px;
			line-height: 100%;
			letter-spacing: 0;
		}
		&__company {
			color: var(--company-position-large);
			font-weight: 400;
			font-size: 13px;
			line-height: 100%;
			letter-spacing: 0;
			margin-bottom: 2px !important;
		}
	}
}
</style>
